import { Platform } from 'react-native'

import type { AuthProvider as AuthProviderType } from './AuthContext.types'

// Keep a shared entrypoint for app imports without eagerly evaluating the web
// implementation on native, which would initialize auth0-spa-js in the simulator.
const authContextModule =
  Platform.OS === 'web'
    ? // eslint-disable-next-line @typescript-eslint/no-require-imports
      require('./AuthContext.web')
    : // eslint-disable-next-line @typescript-eslint/no-require-imports
      require('./AuthContext.native')

export const AuthProvider = authContextModule.AuthProvider as AuthProviderType
